import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { LiteralsState } from '../../reducers/literals.reducer';
import * as selectors from '../../selectors/literals/campaign-management.selectors';

@Injectable({
  providedIn: 'root',
})
export class CampaignManagementLiteralsFacadeService extends FacadeService {
  constructor(public override store: Store<LiteralsState>) {
    super(store);
  }

  // OBSERVABLES
  campaignName$ = this.storeSelect(selectors.getCampaignName);
  schema$ = this.storeSelect(selectors.getSchema);
  country$ = this.storeSelect(selectors.getCountry);
  channel$ = this.storeSelect(selectors.getChannel);
  startDate$ = this.storeSelect(selectors.getStartDate);
  endDate$ = this.storeSelect(selectors.getEndDate);
  id$ = this.storeSelect(selectors.getId);
  description$ = this.storeSelect(selectors.getDescription);
  date$ = this.storeSelect(selectors.getDate);
  tableSchema$ = this.storeSelect(selectors.getTableSchema);
  tableCountry$ = this.storeSelect(selectors.getTableCountry);
  tableChannel$ = this.storeSelect(selectors.getTableChannel);
  tableCost$ = this.storeSelect(selectors.getTableCost);
  tableGroup$ = this.storeSelect(selectors.getTableGroup);
  tableMembers$ = this.storeSelect(selectors.getTableMembers);
  tableProgress$ = this.storeSelect(selectors.getTableProgress);
  executionDate$ = this.storeSelect(selectors.getExecutionDate);
  insertNumeric$ = this.storeSelect(selectors.getInsertNumeric);
  insertNewExecDate$ = this.storeSelect(selectors.getInsertNewExecDate);
  campaignProcessed$ = this.storeSelect(selectors.getCampaignProcessed);
  downloadRecipientsHeader$ = this.storeSelect(selectors.getDownloadRecipientsHeader);
  downloadRecipients$ = this.storeSelect(selectors.getDownloadRecipients);
  executionId$ = this.storeSelect(selectors.getExecutionId);
  executionTitle$ = this.storeSelect(selectors.getExecutionTitle);
  executionDescription$ = this.storeSelect(selectors.getExecutionDescription);
  campaignExecutionDate$ = this.storeSelect(selectors.getCampaignExecutionDate);
  controlGroup$ = this.storeSelect(selectors.getControlGroup);
  excluded$ = this.storeSelect(selectors.getExcluded);

  // OBSERVABLE'S VALUES
  get id() {
    return this.storeSnapshot(this.id$);
  }

  get campaignName() {
    return this.storeSnapshot(this.campaignName$);
  }

  get description() {
    return this.storeSnapshot(this.description$);
  }

  get date() {
    return this.storeSnapshot(this.date$);
  }

  get tableCountry() {
    return this.storeSnapshot(this.tableCountry$);
  }

  get schema() {
    return this.storeSnapshot(this.schema$);
  }

  get tableChannel() {
    return this.storeSnapshot(this.tableChannel$);
  }

  get tableCost() {
    return this.storeSnapshot(this.tableCost$);
  }

  get tableGroup() {
    return this.storeSnapshot(this.tableGroup$);
  }

  get tableMembers() {
    return this.storeSnapshot(this.tableMembers$);
  }

  get tableProgress() {
    return this.storeSnapshot(this.tableProgress$);
  }

  get executionDate() {
    return this.storeSnapshot(this.executionDate$);
  }

  get campaignProcessed() {
    return this.storeSnapshot(this.campaignProcessed$);
  }
}
